import StudioLanding from "@/pages/studio/StudioLanding";
import { Seo } from "@/seo/Seo";
import { organization, softwareApplication } from "@/seo/schema";

export default function Home() {
  return (
    <>
      <Seo path="/" jsonLd={[organization(), softwareApplication("fr")]} />
      <StudioLanding />
    </>
  );
}
